import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { constants, selectors, verifiers } from '@yola/subscription-manager-js';
import user from 'src/js/modules/user';
import routesMap from 'src/js/router/helpers/routes-map';
import redirectToUrl from 'src/js/utils/redirect-to-url';
import utils from 'src/js/modules/webapp-plugins/utils';
import useSupportedSearchParams from '../hooks/use-supported-search-params';
import { premiumFeatures } from '../../modules/common/constants/premium-features';

const { DOMAIN_SUBSCRIPTION } = constants.SubscriptionType;
const { CUSTOM_DOMAIN } = premiumFeatures;

function InitiatePurchaseRoute() {
  const navigate = useNavigate();
  const searchParams = useSupportedSearchParams();
  const currentPlanType = useSelector(selectors.getCurrentPackageType);
  const isB2C = useSelector(user.selectors.getIsB2C);

  useEffect(() => {
    if (!searchParams || !currentPlanType) return;

    const { premiumFeature, domain, term } = searchParams;
    const isFree = verifiers.isFreeHostingPackageType(currentPlanType);

    if (premiumFeature === CUSTOM_DOMAIN && domain) {
      if (isFree) {
        navigate(
          routesMap.initiateUpgrade.url({
            query: searchParams,
          }),
          { replace: true }
        );
      } else {
        redirectToUrl(
          utils.generatePaymentUrl(
            {
              products: [DOMAIN_SUBSCRIPTION],
              domain_name: domain,
              ...(term && { term }),
            },
            isB2C
          )
        );
      }
      return;
    }

    navigate(routesMap.home.url(), { replace: true });
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, [searchParams, currentPlanType]);

  return null;
}

export default InitiatePurchaseRoute;
